import { Controller } from "@hotwired/stimulus";

const fold = (text: string) => text.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase();

// Connects to data-controller="saved-map-search"
// Criar mapa's Meus Mapas step: the maps whose name has the typed words, accents and case aside.
export default class extends Controller<HTMLElement> {
	static targets = ["input", "item", "empty"];
	declare readonly inputTarget: HTMLInputElement;
	declare readonly itemTargets: HTMLElement[];
	declare readonly emptyTarget: HTMLElement;

	filter() {
		const words = fold(this.inputTarget.value).split(/\s+/).filter(Boolean);
		let shown = 0;
		for (const item of this.itemTargets) {
			const name = fold(item.dataset.name ?? "");
			item.hidden = !words.every((word) => name.includes(word));
			if (!item.hidden) shown += 1;
		}
		this.emptyTarget.hidden = shown > 0;
	}
}
